enum MenuType {
    TYPE_URL='url',
    TYPE_ROUTE='route',
    TYPE_GROUP='group'
}
enum TargetType {
    TARGET_PAGE  = '_top',
    TARGET_BLANK = '_blank',
    TARGET_MATRIX = '_matrix',
}
export {MenuType,TargetType}